export default "__VITE_ASSET__DykrvdM4__"